
import {
  usesg,
  solotionTabItems,
  popularServices,
  questions,
} from "~/data/loadbalancer";
import Modal from "../../components/rebranding/modal/Modal.vue";

export default {
  components: {
    Modal,
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title: "لود بالانسر‌ آبالون |‌ راهکار توزیع بار ترافیک‌های سازمانی",
      meta: [
        {
          name: "description",
          content:
            "توزیع بار هوشمند سرورها با لود بالانسر آبالون | مسیر ترافیک کاربران را حرفه‌ای هدایت کنید | راهکارهای لود بالانسینگ ابری آبالون",
        },
        {
          name: "keywords",
          content: "لود بالانسینگ , لود بالانسر",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/loadbalancer",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "لود بالانسر‌ آبالون |‌ راهکار توزیع بار ترافیک‌های سازمانی",
        },
        {
          property: "og:description",
          content:
            "توزیع بار هوشمند سرورها با لود بالانسر آبالون | مسیر ترافیک کاربران را حرفه‌ای هدایت کنید | راهکارهای لود بالانسینگ ابری آبالون",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/loadbalancer",
        },
        {
          name: "twitter:creator",
          content: "@themetrades",
        },
        {
          name: "twitter:title",
          title: "لود بالانسر‌ آبالون |‌ راهکار توزیع بار ترافیک‌های سازمانی",
        },
        {
          name: "twitter:description",
          content:
            "توزیع بار هوشمند سرورها با لود بالانسر آبالون | مسیر ترافیک کاربران را حرفه‌ای هدایت کنید | راهکارهای لود بالانسینگ ابری آبالون",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/loadbalancer",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "تفاوت انواع لود بالانسر آبالون در چیست؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "آبالون سه مدل لود بالانسر DNS، مبتنی بر HTTP و ابری (VPC) ارائه می‌دهد که هرکدام متناسب با نیازهای مختلف زیرساختی و عملیاتی مانند نوع ترافیک، مکان سرورها و الگوریتم‌های مسیریابی انتخاب می‌شوند.",
                },
              },
              {
                "@type": "Question",
                name: "آیا لود بالانسر ابری آبالون برای سرورهای خارج از دیتاسنتر هم قابل استفاده است؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله، لود بالانسر ابری آبالون می‌تواند ترافیک را بین ماشین‌های مجازی یا سرورهای دارای IP عمومی یا خصوصی در هر نقطه از ایران یا جهان توزیع کند.",
                },
              },
              {
                "@type": "Question",
                name: "آیا امکان استفاده از الگوریتم‌های سفارشی برای توزیع ترافیک وجود دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله، لود بالانسرهای آبالون از الگوریتم‌های متنوعی مثل Round-Robin و Source IP Hash پشتیبانی می‌کنند و امکان تنظیم سیاست‌های سفارشی بر اساس نیاز اپلیکیشن‌های Stateful یا Stateless وجود دارد.",
                },
              },
              {
                "@type": "Question",
                name: "قابلیت SSL/TLS Termination در لود بالانسر چه کاربردی دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "با این قابلیت، ارتباط امن کاربران در لایه لود بالانسر پایان می‌یابد و ترافیک به صورت دیکریپت شده به سمت سرورهای اصلی ارسال می‌شود که باعث کاهش بار پردازشی سرورها و بهبود عملکرد می‌شود.",
                },
              },
              {
                "@type": "Question",
                name: "اگر یکی از سرورها یا مسیرها دچار مشکل شود، چه اتفاقی برای ترافیک می‌افتد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "با بهره‌گیری از قابلیت مسیریابی هوشمند و مانیتورینگ سلامت سرورها، لود بالانسر آبالون به‌طور خودکار سرور یا مسیر جایگزین را انتخاب می‌کند تا ارتباط بدون قطعی برای کاربران حفظ شود.",
                },
              },
            ],
          },
        },
      ],
    };
  },
  data() {
    return {
      title: "لود بالانسر‌ آبالون |‌ راهکار توزیع بار ترافیک‌های سازمانی",
      FormTitle: "ثبت درخواست ارتباط با واحد فروش",
      usesg,
      solotionTabItems,
      popularServices,
      questions,
      activeSection: "",
      tab: 0,
      solotionTab: 0,
      showmore: false,
    };
  },
  mounted() {},
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
  },
};
